import { SlideConfig } from '../config/whitelabel-config.model';

export interface RouteLanding {
  origin: string;
  destination: string;
  slug: string;
  path: string;
  image: string;
}

export function routeLandingFromSlide(slide: SlideConfig): RouteLanding | null {
  const cities = String(slide.description || '')
    .split(/\s*(?:→|->|–|—)\s*/)
    .map(city => city.trim())
    .filter(Boolean);

  if (cities.length !== 2) {
    return null;
  }

  const [origin, destination] = cities;
  const slug = `${citySlug(origin)}-to-${citySlug(destination)}`;
  if (slug === '-to-') {
    return null;
  }

  return {
    origin,
    destination,
    slug,
    path: `/routes/${slug}`,
    image: slide.image || ''
  };
}

export function configuredRouteLandings(slides: SlideConfig[]): RouteLanding[] {
  const routes = (slides || [])
    .map(routeLandingFromSlide)
    .filter((route): route is RouteLanding => !!route);

  return routes.filter((route, index) =>
    routes.findIndex(candidate => candidate.slug === route.slug) === index
  );
}

export function findRouteLandingByPath(
  slides: SlideConfig[],
  path: string
): RouteLanding | null {
  return configuredRouteLandings(slides).find(route => route.path === path) || null;
}

function citySlug(city: string): string {
  return city
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}
